import React from 'react';
import { ImagePlayer, IImagePlayerProps } from './../components/ImagePlayer';
import { Ad } from './Ad';

export class ImageAd extends Ad {
    Component: () => React.FunctionComponentElement<IImagePlayerProps> = () =>
        React.createElement(ImagePlayer, { ad: this });
}
